import { ToastInterface } from '../redux/reducers/toast/toastState';

export const emptyToastState: ToastInterface = {
    toastMessage: '',
    toastType: undefined,
};
